import type { FaireProductEntity } from "../../entity_types/product";

export const p_dckfbptkes: FaireProductEntity = {
  token: "p_dckfbptkes",
  type: "product",
  name: "Peace to my Soul - Customizable - Long Sleeve Tee",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/b70528973d4c756a1c09d75c51d5df815bc90beb4642000ed6da6bcbf6ad507f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da21a436a52f213de74bb4f9089c96a690c3f9c6b15fef69c1591fdebd04d368.png",
    "https://cdn.faire.com/fastly/d7bdc4387b04e1ca9ef8feb5a94a58a82b08b29e3eef5ad70ea5aff8b54d6f4c.png",
    "https://cdn.faire.com/fastly/1f9cd6fd065d3a061df2a3bb916d9fd5a87cab1fbd97a739cee5e758a75529f3.png"
  ],
  priceDollars: 15,
  description: "Our Peace to my Soul customizable graphic is now available on a Unisex Long Sleeve Tee.\n\nIn the space provided please enter your custom location. We will replace Twain Harte, Sunapee, Stowe and Glacier with your location.\n\nOur Unisex long sleeve tee is manufactured by Bella Canvas and is available in X-Small thru 3X-Large.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:50.552Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
